import { render } from "./news-video.vue?vue&type=template&id=b62995f4&scoped=true"
import script from "./news-video.vue?vue&type=script&lang=js"
export * from "./news-video.vue?vue&type=script&lang=js"

import "./news-video.vue?vue&type=style&index=0&id=b62995f4&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b62995f4"]])

export default __exports__